import { motion } from 'framer-motion';

const transition = { duration: 0.4, ease: 'easeOut' };

const Dialog: React.FC<{ close?: () => void; contentClasses?: string }> = ({
    children,
    close,
    contentClasses,
}) => {
    return (
        <div className="modal-show absolute inset-0 h-full w-full" style={{ zIndex: 100 }}>
            <motion.div
                onClick={close}
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={transition}
                className="modal-overlay z-50"
            ></motion.div>

            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={transition}
                className={`modal-content w-90p select-none ${contentClasses}`}
            >
                {children}
            </motion.div>
        </div>
    );
};

export default Dialog;
